import React, { useMemo } from "react";
import styles from "./Stores.module.css";
import { TopBar } from "../../components/TopBar/TopBar";
import { useSeo } from "../../utils/useSeo";
import { buildStoresPage } from "../../seo/storesPage";

// What the prerender knew about each store (scripts/prerender-meta.js): brand
// counts, categories, best discount, and which stores had a home that build.
const readSeed = () => {
  try {
    const el = typeof document !== "undefined" && document.getElementById("stores-seed");
    return el ? JSON.parse(el.textContent || "null") : null;
  } catch {
    return null;
  }
};

/**
 * /stores, "Fleek around the world": every store with a home of its own.
 * A plain link to each store's home; opening it opens that store.
 */
export const Stores = () => {
  const page = useMemo(() => {
    const seed = readSeed();
    return buildStoresPage(seed ? { stores: seed.stores, countries: seed.countries } : {});
  }, []);

  useSeo({ title: page.title, description: page.description, canonical: page.url, jsonLd: page.jsonLd });

  return (
    <div className={styles.page}>
      <TopBar title="Stores" backTo="/marketplace" />
      <div className={styles.shell}>
        <h1 className={styles.title}>{page.heading}</h1>
        <p className={styles.intro}>{page.description}</p>
        <ul className={styles.list}>
          {page.cards.map((c) => (
            <li key={c.country}>
              {/* A full page load: the store's own address opens that store. */}
              <a className={styles.card} href={c.href}>
                <span className={styles.flag} aria-hidden="true">{c.flag}</span>
                <span className={styles.main}>
                  <span className={styles.name}>{c.name}</span>
                  <span className={styles.meta}>
                    Prices in {c.currency}
                    {c.count ? ` · ${c.count} brands` : ""}
                    {c.categories.length ? ` · ${c.categories.join(", ")}` : ""}
                  </span>
                </span>
                {c.maxPct > 0 && <span className={styles.pct}>Up to {c.maxPct}% off</span>}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Stores;
